export const SITE_NAME = '蜜糖社区';
export const SITE_TAGLINE = '热爱生活的人，都在这里相遇';
export const CURRENT_USER_ID = 'u1';
export const PAGE_SIZE = 6;